import ContactInfo from './ContactInfo';
import { UserRole } from './UserRole';
import Product from './Product';
import CollectedProduct from './CollectedProduct';
import { UserStatus } from './UserStatus';
import { EmailType } from './EmailType';

export default class User {
    public userId: string;
    public firstName: string;
    public lastName: string;
    public contactInfo: ContactInfo;
    public password: string;
	public creationDateTime: string;
    public role: UserRole;
    public status: UserStatus;
    public collectedProducts: CollectedProduct[];
    public likedProducts: Product[];
    public characterId: string;
    public emailPreferences: Map<EmailType, boolean>;
    public collectionId: string;
    public defaultCurrencyCode: string;
}
